import { Component, OnInit, Input, AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ErrorMessage } from '../../../api/models/error-message';
import { FormGroup } from '@angular/forms';
import { trigger, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeInOut', [
        transition(':enter', [
            style({opacity: 0}),
            animate(300, style({opacity: 1}))
        ]),
        transition(':leave', [
            animate(300, style({opacity: 0}))
        ])
    ])
  ]
})
export class ErrorMessageComponent implements OnInit, AfterContentChecked {

    @Input() errormessage: ErrorMessage;
    @Input() form?: FormGroup;
    @Input() bgStyle: string;

    constructor(
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit() {

        this.errormessage =  {
            show: false
        };

        this.hideMessageOnValidForm();
    }

    ngAfterContentChecked() {
        /**
         * This function hides existing
         * error message after 5 secs
         */
        if (this.errormessage.show === true) {
            const timeout = setTimeout(() => {
                this.cd.markForCheck();
                this.errormessage = {
                    show:  false
                };
                clearTimeout(timeout);
            }, 4000);
        }

    }

    /**
     * This function hides existing
     * error message if form becomes valid
     */

    hideMessageOnValidForm(): void {
        if (this.form) {
            this.form.statusChanges.subscribe(status => {
                if (status === 'VALID') {
                    this.errormessage.show = false;
                }
            });
        }
    }

    closeModal() {
        this.errormessage.show = false;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/error-message/error-message.component.ts